<div class="flex flex-col items-center gap-8">
  @if (icon() || subtitle()) {
    <h3 class="flex items-center text-xl text-gray-500">
      @if (icon(); as icon) {
        <tui-icon [icon]="icon" class="mr-2" />
      }
      @if (subtitle(); as subtitle) {
        <span>{{ subtitle }}</span>
      }
    </h3>
  }
  <div class="flex flex-col items-center gap-4 text-center">
    <h2 class="text-3xl font-bold md:text-4xl">
      {{ title() }}
    </h2>
    @if (descriptionInput(); as description) {
      <p class="text-balance text-xl">
        {{ description }}
      </p>
    }
    @if (descriptionContentChild(); as description) {
      <p
        class="text-balance text-xl"
        [innerHTML]="description.nativeElement.innerHTML"
      ></p>
    }
  </div>
</div>
